export const messageActionTypes = {
  SUCCESS_MESSAGE: 'SUCCESS_MESSAGE',
  ERROR_MESSSAGE: 'ERROR_MESSAGE',
  REMOVE_MESSAGE: 'REMOVE_MESSAGE'
};